<template>
  <div class="bind-page">
    <GSHeader :text="getHeaderText()"></GSHeader>
    <div class="main-panel" v-bind:class="{ 'wide-panel': widerPanel() }">
      <router-view
        @show-policy="showPolicyPopup"
        @show-loading="showLoadingToast"
        @show-warning="showWarningToast"
      ></router-view>
    </div>
    <GSPopup
      v-if="showPolicy"
      :title="$t('title__user_agreement')"
      @closed="showPolicyPopup(false)">
      <div
        slot="content"
        class="policy-content"
        v-html="policyContent"
      ></div>
    </GSPopup>
    <GSToastWarn :text="toastText" type="warn" :show="showWarning" @clicked="warningClicked()"></GSToastWarn>
    <GSToastLoading text="Loading..." :show="showLoading" ></GSToastLoading>
  </div>
</template>

<script>
import GSHeader from '@/components/GSHeader'
import GSToastWarn from '@/components/GSToastWarn'
import GSToastLoading from '@/components/GSToastLoading'
import GSPopup from '@/components/GSPopup'

import BindBaseMixin from './mixins/BindBaseMixin'

export default {
  name: 'BasePage',
  mixins: [BindBaseMixin],
  components: {
    GSHeader,
    GSPopup,
    GSToastWarn,
    GSToastLoading
  },
  data () {
    return {
      showPolicy: false,
      showLoading: false,
      showWarning: false,
      warningClickable: true,
      policyContent: '',
      toastText: this.$t('error__wrong_verification_code')
    }
  },
  watch: {
    $route (to, from) {
      this.showWarning = false
    }
  },
  methods: {
    showPolicyPopup (value) {
      this.showPolicy = value == null ? true : value
      if (this.showPolicy & !this.policyContent) {
        this.showLoadingToast(true)
        this.request('get',
          this.getApiUrl('pp'), {
            locale: this.$store.getters['bind/requestParams'].locale
          }, (data) => {
            this.policyContent = data['pp']
            this.showLoadingToast(false)
          })
      }
    },
    showLoadingToast (value) {
      this.showLoading = value == null ? true : value
    },
    showWarningToast (text, clickable = true) {
      this.warningClickable = clickable
      this.toastText = text
      this.showWarning = true
    },
    warningClicked () {
      this.warningClickable && (this.showWarning = false)
    },
    widerPanel () {
      return this.bindEmail && this.$route.name === 'bind-verify'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/vars/base';

.bind-page {
  position: absolute;
  min-height: 100%;
  width: 100%;
  background-image: url('https://cdngarenanow-a.akamaihd.net/webmain/static/game_service/bind/img_bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center top;
}

.main-panel {
  width: 100%;
  max-width: $base-size * 1000;
  margin: auto;
}

.wide-panel {
  max-width: $base-size * 1200;
}

.policy-content {
  font-size: $base-size * 24;
  text-align: left;
  letter-spacing: 0;
  line-height: $base-size * 46;
}

</style>



// WEBPACK FOOTER //
// src/pages/bind/BasePage.vue